import React from 'react';
import MenuContent from '../MenuContent';
import NavList from '../NavList';

const ForEveryoneBlock = ({ forEveryone }) => {

  const { heading, subHeading, links } = forEveryone;

  return (
    <MenuContent className="for-everyone-block">
      <NavList>
        <div className="heading-wrapper visible-md-up">
          <i className="icon-planner" />
          <h4>
            {heading}
            <span className="sub-heading d-block">
              {subHeading}
            </span>
          </h4>
        </div>
        <ul className="col-lg-2">
          {links.map(item => (
            <li key={item.label}>
              <a href={item.link}>{item.label}</a>
            </li>
          ))}
        </ul>
      </NavList>
    </MenuContent>
  );
};

ForEveryoneBlock.defaultProps = {
  forEveryone: {}
};

export default ForEveryoneBlock;




// WEBPACK FOOTER //
// ./js/components/global/menu/menuBlocks/ForEveryoneBlock.js